<template>
  <div class="paginator" v-if="end">
    <el-dropdown
      class="dropmenu"
      @command="handleCommand"
      v-if="pages.length > 0"
    >
      <el-button class="current-location-btndrop">
        {{ pageSize }}<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown" style="width: 80px">
        <el-dropdown-item
          class="subdropitem"
          v-for="(item, index) in pages"
          :key="index"
          :command="item"
          >{{ item }}</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
    <span style="margin-left: 10px; font-size: 14px"
      >Mostrando de {{ start }} até {{ end }} de {{ total }} itens</span
    >
  </div>
</template>

<style scoped>
.paginator {
  margin-top: 30px;
}
.current-location-btndrop {
  height: 43px !important;
  width: 70px;
  font-size: 14px !important;
  background-color: #f1f1f1 !important;
  border: none !important;
  color: #515151 !important;
  font-weight: normal !important;
}
</style>

<script>
export default {
  name: "Paginator",
  template: "#paginator",
  data() {
    return {
      number: this.end - this.start + 1,
      pages: [],
    };
  },
  props: {
    start: Number,
    end: Number,
    total: Number,
    pageSize: Number,
  },
  created() {
    this.handlePages();
  },
  watch: {
    total() {
      this.number = this.end - this.start + 1;
      this.pages = [];
      this.handlePages();
    },
  },
  methods: {
    handlePages() {
      let multTemp = 3;
      if (this.total < this.pageSize) {
        this.pages.push(this.pageSize);
        return;
      }
      if (this.total > 500) {
        multTemp = 10;
      }
      for (let i = this.number; i < this.total; i += this.number * multTemp) {
        this.pages.push(i);
      }
      this.pages.push(this.total);
    },
    handleCommand(command) {
      this.number = command;
      this.$emit("set-page-size", {
        size: command,
      });
    },
  },
};
</script>
